export default {
  user: {
    online: false,
    email: null,
    userJWT: null,
  },
};
